export const BATCH_UNASSIGNMENT_IMG = '/assets/common/batch-assignment.svg';

export enum CoachAssignmentStatus {
  PartialSuccess = 'partialSuccess',
  Success = 'success',
  Failure = 'failure',
  Error = 'error',
}
export const RELEASE_DATE = new Date('2024-04-20');
